import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const LettersPath = styled.path.attrs(props => ({
  fill: props.reverse
    ? props.theme.mainColor
    : props.theme.secondaryBackgroundColor,
  d: 'M0 2356.9h33.3v112.4h32.2v-112.4h33.3v-27.2H0zM236.9 2372.5c0 12.1-8.6 19.1-22.2 19.1-3 0-6.6 0-8.1-.5v-35.8c2 0 5.5-.5 8.6-.5 15.1-.4 21.7 6.6 21.7 17.7zm43.3 96.8l-29.2-44.9c-3.5-5-7.1-10.6-10.6-15.6 18.6-4 30.7-20.2 30.7-38.3 0-29.7-20.2-41.3-52.4-41.3-17.1 0-31.7 0-43.3.5v139.6h31.7v-54.9h1.5l33.3 54.9h38.3zM356.3 2469.3v-139.6H388v139.6h-31.7zM931.8 2469.3l-9.6-58c-2-11.6-3-22.2-4-32.8h-1c-2 10.6-4 20.7-8.1 32.8l-17.1 56.9h-31.2l-16.1-51.9c-3.5-12.1-7.1-25.7-9.1-37.8-1.5 12.6-3 23.7-4 35.8l-7.1 54.9h-32.8l22.2-139.6h36.8l19.1 61c3 10.1 5.5 19.1 7.1 30.7h.5c2-11.6 4-20.2 8.1-30.7l20.2-61H942l22.2 139.6h-32.4zM1032.1 2469.3v-139.6h79.1v27.2h-46.4v27.7h43.8v26.2h-43.8v30.7h46.4v27.7c-.5.1-79.1.1-79.1.1zM1246.7 2356.9v112.4h-32.3v-112.4h-33.3v-27.7h98.8v27.7h-33.2z',
}))``;

function DynamicFullLogo({ title, inverse }) {
  return (
    <svg width="100%" height="100%" viewBox="0 2253.6 1280 293.3">
      {title ? <title>{title}</title> : null}
      <LettersPath reverse={inverse} />
      <path
        fill="#D14727"
        d="M743.8 2400.3c0 81.1-65.5 146.6-146.6 146.6s-146.6-65.5-146.6-146.6c1-81.1 66.5-146.6 146.6-146.6 81.1-.1 146.6 65.4 146.6 146.6z"
      />
      <path
        fill="#FFF"
        d="M674.8 2358.9c-3.5-39.3-36.3-70.6-76.6-70.6-39.8 0-73.1 30.7-76.6 69.5-20.2 15.1-31.2 38.3-31.2 62 0 12.6 3.5 26.2 10.6 38.3 14.1 24.7 40.3 38.3 67 38.3 10.1 0 20.7-2 29.7-6.6 10.1 4 20.2 6.6 30.7 6.6 26.2 0 52.4-14.1 67-38.3 7.1-12.1 10.6-25.7 10.6-38.3-.5-22.6-11.1-46.3-31.2-60.9zm-76.6-46.3c22.7 0 41.8 13.6 49.9 33.3-6.6-1.5-12.6-3-20.2-3-27.2 0-52.4 13.6-67 38.3-3 5-5 10.6-6.6 15.6-6.6-8.6-10.1-20.2-10.1-31.2.1-29.3 23.7-53 54-53zm15.6 81.1c3.5 7.1 6.6 14.1 7.1 21.2-7.1 3.5-15.1 5-22.7 5-8.6 0-16.1-2-23.7-5.5.5-7.1 3-14.1 7.1-20.7 4-7.1 10.1-12.6 16.1-17.6 6.5 4 12.6 10.5 16.1 17.6zm-93.2 53.4c-5-8.6-7.1-17.6-7.1-27.2 0-11.6 3.5-22.7 10.6-32.3 9.1 32.3 39.3 54.9 74.1 54.9 6.6 0 12.6-.5 19.1-2-4 10.6-12.1 20.2-22.7 25.7-8.6 5-17.6 7.1-27.2 7.1-18.6.5-36.8-8.5-46.8-26.2zm154.2.5c-10.1 17.1-27.7 27.2-46.9 27.2h-5c14.1-14.1 22.2-34.3 21.2-53.9 0-12.6-3.5-26.2-10.6-38.3-3-5.5-7.1-10.1-11.6-15.1h5c9.1 0 18.6 2 27.2 7.1 17.1 10.1 27.2 27.7 27.2 46.9.5 8.5-1.5 17.6-6.5 26.1z"
      />
    </svg>
  );
}

DynamicFullLogo.propTypes = {
  /** Svg title */
  title: PropTypes.string,
  /** Whether to inverse the logo */
  inverse: PropTypes.bool,
};

DynamicFullLogo.defaultProps = {
  title: null,
  inverse: false,
};

export default DynamicFullLogo;
